/**
 * CRA inlines `REACT_APP_*` at compile time. Read via one helper so all GIPHY UI stays consistent.
 */
export function getGiphyApiKey(): string {
  const raw = process.env.REACT_APP_GIPHY_API_KEY;
  if (raw == null) return "";
  const t = String(raw).trim();
  return t === "" || t === "undefined" || t === "null" ? "" : t;
}
